import * as React from 'react';
import {
    useDispatch,
    useSelector,
  } from 'react-redux';
import { useCtx } from 'one-ui-provider';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Avatar from 'antd/lib/avatar';
import Select from 'antd/lib/select';
import Skeleton from 'antd/lib/skeleton';
import Badge from 'antd/lib/badge';
import {
    FinessePhonePlugin
} from 'one-comp-phone';
const {
    Option,
} = Select;

import {
    Value,
    Values,
} from 'one-ui-values';

import {
    //CardNoData,
    CardVerifySource,
    Card,
} from 'one-ui-card';

import {
    SourceCardProps,
} from './props';

import {
    setAction as addNewFormAction
  } from 'one-state-addnew';

let patientvalue:any, finalpatientcount:any = 0;

export const SourceCardSimple = (
    props: SourceCardProps
) => {
    const {
        title,
        source,
        sourcePath,
        verifySource,
        skeleton,
        patientcount,
    } = props;

    const {
        source_skeleton,
        subject_skeleton,
    } = skeleton;
    const { makecall, settings } = useCtx();
    const choosecaller = useSelector((state: any) => (state.choosecaller));
    const dispatch = useDispatch();
    const { uisettings: { source_card,preferred_name }, compatible: { contact_center_type }, epicendpoints: { searchID } } = settings;
    const {
        name_display,
        preferred_name_display,
        dob_display,
        mrn_display,
        callertype_display,
        contactnumber_display,
        address_display,
        age_gender_at_title_display,
        email_display,
        ssn_display,
        department_display
    } = source_card;
    let  countvar:any = 0;
    let badgecount = ((source?.values?.length) ? (source.values.length) : 0);

      // SourceCount Should Not Increase when searching globally for patient as per ADPAC-2522
      if (patientcount !== undefined && countvar < 1){
        countvar++;
        patientvalue = patientcount;
        finalpatientcount = patientcount;
    }
    else if (countvar >= 1){
        finalpatientcount = patientvalue;
    }

    let validsearchid = "";

    if (searchID == "MRN"){
        validsearchid = "MRN"
    }
    else if (searchID == "EPI") {
        validsearchid = "EPI"
    }

    // append patients from epic to count
    if (finalpatientcount) {
        if (contact_center_type && contact_center_type === 'five9') {
            let five9ani = sessionStorage.getItem("ani");
            if(five9ani && five9ani?.length > 0){
                badgecount = badgecount + finalpatientcount;
            }
        }else if(contact_center_type && (contact_center_type === 'finesse'  || contact_center_type === 'wxcc')){
            if(choosecaller && choosecaller?.dnis?.length > 0){
                badgecount = badgecount + finalpatientcount;
            }
        }else{
            badgecount = badgecount + finalpatientcount;
        }
    }
    //remove the patient/source record push on select in source
    if (source?.values) {
        source.values.forEach((record) => {
            if (record.mrn || ("providers" in record)) {
                badgecount = badgecount - 1;
            }
        })
    }
    // set default screen on intital/reset screen
    let result = (
        <Row type="flex">
            <div style={{width: '80px'}}>
                <a onClick={() => { verifySource(true); }} style={{ marginLeft: '15px' }} className="avatar-badge">
                    <Badge count={badgecount} >
                        <Avatar size="large">{source?.selected?.initials}</Avatar>
                    </Badge>
                </a>
            </div>
            <Row type="flex" gutter={[16, 32]} style={{ flex: 1 }}>
                <Col span={24}>
                    {(name_display) && ((source?.selected?.firstname) || (source?.selected?.lastname)) &&
                        (<div className="description-info__name">
                            <span>{source?.selected?.lastname}   {source?.selected?.firstname} {(preferred_name)&&(source?.selected?.preferredName)&&'"'+source?.selected?.preferredName+'"'}</span>
                            <a onClick={() => {
                                verifySource(true);
                            }}>Change</a>
                        </div>)
                    }
                    <Row type="flex" gutter={[40, 28]}>
                        <Col span={14}>
                            <Values>
                                {/* <Value
                                    label='Contact number'
                                    value={source?.selected?.contact}
                                /> */}
                                {preferred_name_display && (
                                    <Value label="Preferred Name" value={source?.selected?.preferredName ? source?.selected.preferredName : ''} />
                                )}
                                {
                                    (contactnumber_display) && (<FinessePhonePlugin
                                        label='Contact Number'
                                        phone={source?.selected?.contact_formatted}
                                        type={'source'}
                                        makecall={makecall} />)
                                }
                                {
                                    (email_display) && (
                                        <Value label="Email" value={source?.selected?.email} />
                                    )
                                }
                                {
                                    (address_display) && (<Value
                                        label="Address"
                                        value={source?.selected?.address}
                                    />)
                                }
                            </Values>
                        </Col>
                        <Col span={10}>
                            <Values>
                                {
                                    (callertype_display) && (source?.selected?.subtypename) && (
                                        <Value label="Caller Type" value={source?.selected?.subtypename} />
                                    )
                                }
                                {
                                    (dob_display) && (source?.selected?.dob) && (
                                        <Value label="DOB" value={source?.selected?.dob} />
                                    )
                                }
                                {
                                    (department_display) && (source?.selected?.department) && (
                                        <Value label="Department" value={source?.selected?.department} />
                                    )
                                }
                                {
                                    (mrn_display) && (source?.selected?.mrn) && (
                                        <Value label= { validsearchid } value={source?.selected?.mrn} />
                                    )
                                }
                                {
                                    (ssn_display) && (source?.selected?.ssn) && (
                                        <Value label="Last 4 SSN" value={source?.selected?.ssn} />
                                    )
                                }
                            </Values>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Row>
    );

    //Check for No Data
    if (source?.values?.length == 0 && ('selected' in source) && source?.selected === undefined) {
        result = (
            <>
            <a onClick={() => {
                   dispatch(
                    addNewFormAction(
                      {
                        value: true
                      }
                    )
                  )
                }}>
                {/* <CardAddNew/> */}
            </a>
                
            </>
        );
    }
    // Check if Source is verified or not
    if ((source?.values.length > 0 || source?.values?.length === 0) && ('selected' in source) && source?.selected === undefined) {
        result = (
                <CardVerifySource onClick={() => {
                    verifySource(true);
                }}/>
        );
    }


    if ((source_skeleton && subject_skeleton) ||
        (source_skeleton && !subject_skeleton) ||
        (!source_skeleton && subject_skeleton)) {
        result = (<Skeleton avatar active paragraph={{ rows: 3 }} />);
    }
    let sourcepersona = title;
    if (source?.selected) {
        if (sourcePath === "patient") {
            sourcepersona = title + " is a Patient";
        }
        else if (source?.selected.subtypename) {
            sourcepersona = title + " is " + source?.selected.subtypename;
        }
        else if(source?.selected?.typename) {
            sourcepersona = title + " is " + source?.selected?.typename;
        }
        else if (('mrn' in source?.selected) || ('dob' in source?.selected)) {
            sourcepersona = title + " is a Patient Rep";
        }
    }
    let sourceTitle = sourcepersona;
    if (age_gender_at_title_display) {
        sourceTitle = sourcepersona?.concat(source?.selected?.age ? " (" + source?.selected?.age + " year old " + source?.selected.gender + ")" : "");
    }
    return (
        <Card
            // note={checkfornote(source, type)}
            // title={title?.concat(source?.selected?.age?" ("+source?.selected?.age+" year old "+source?.selected.gender+")":"")}
            title={sourceTitle}
            // Removing gear icon as per ticket number ADPAC-2221
            // gearActions={
            //     buildGearActionsMenu(
            //         gearActions,
            //     )
            // }
            body={
                result
            }
        />
    );
};
